module.exports = __webpack_public_path__ + "media/images/caregiver/caregiver_avatar_01-c176530b5883dd30ac1e0bfe29fcd536.png";